<template>
    <div v-for="(list, key) in lists" :key="key" class="question-list" :class="list.score < 0 ? 'is_watched' : ''">
        <div class="question-votes">
            <p class="question-votes">{{list.score ? list.score : '0'}} votes</p>
            <p class="question-answer" :class="is_answered==true ? 'answered' : ''">
                <el-icon v-if="is_answered==true"><Check /></el-icon> {{list.answer_count ? list.answer_count : '0'}} answers
            </p>
            <p class="question-views">{{list.view_count ? list.view_count : '0'}} views</p>
        </div>
        <div class="question-content">
            <small class="meta">
                <a href="" class="author" v-html="list.owner.display_name"></a>
                <span class="pr-1"> 
                    asked {{dateTime(list.creation_date)}}
                </span>
            </small>
            <h1>
                <router-link :to="{name: 'question-single', params: {question_id: list.question_id}}" v-html="list.title" />
            </h1>
            <ul v-if="showTags && list.tags" class="question-tags d-flex flex-wrap align-center">
                <li v-for="(tag, index) in list.tags" :key="index">
                    <router-link :to="tag">{{tag}}</router-link>
                </li>
            </ul>
        </div>
    </div>
</template>


<script>
import moment from 'moment'
import {Check} from '@element-plus/icons-vue';


export default {
    name: 'QuestionsLists',
    props: ['lists', 'isLoading', 'showTags'],
    components: {
        Check,
    },
    data() {
        return {
            dateTime(date) {
                return moment(new Date(date * 1000)).fromNow();
            }
        }
    }
}
</script>